import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconLock } from '@sorare/core/src/atoms/icons/system/iconLock.ts';
import { Chip } from '@sorare/core/src/atoms/ui/Chip/index.tsx';

export const SquadPrivateChip = () => (
  <Chip>
    <FontAwesomeIcon icon={iconLock} size="xs" />
    <FormattedMessage defaultMessage="Private" />
  </Chip>
);
